var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('figure',{staticClass:"thumbnail-container",style:(`height: ${_vm.size}px; width: ${_vm.size}px;`),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }